import React from "react";
import {FILE_STATUS_ERROR, URL_STATUS_ERROR} from "../../../constants/FileStatusConstant";
import {useDispatch} from "react-redux";
import {fileDelete} from "../../../actions/FileActions";

function DeleteNotUploadedFileAction({file}) {
    if (file.status !== FILE_STATUS_ERROR && file.status !== URL_STATUS_ERROR) return null;

    const dispatch = useDispatch()

    const handleDeleteFile = () => {
        dispatch(fileDelete(file))
    }
    
    return <img
        className="file-list__delete-file"
        src="/_core/assets/themes/transcription/assets/img/transcription/ico03.svg"
        alt="Delete file"
        onClick={handleDeleteFile}
    />
}

export default DeleteNotUploadedFileAction